import {
    Button,
    createStyles,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    InputBase,
    MenuItem,
    Select,
    TextField,
    Theme,
    withStyles
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import Axios from 'axios';
import { EncryptStorage } from "encrypt-storage";
import { useFormik } from "formik";
import React, { useEffect, useState } from 'react';
import * as yup from "yup";

const validationSchema = yup.object({ 
    school_name: yup.string().nullable(),
    grade_attended: yup.string().nullable(), 
    primary_teacher: yup.string().nullable(),
    school_counselor: yup.string().nullable(),
});

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }),
)(InputBase);

function UpdateSchools(props) {
    const { updateSchool, school }                      = props;
    const [open, setOpen]                       = useState(false); 
    const encryptStorage                        = new EncryptStorage("secret-key");
    const decypt_data                           = encryptStorage.getItem("client_case_id");  
    const [children, setChildren]               = useState([]);
    const [selectedChild, setSelectedChild]     = useState();

    useEffect(() => { 
        Axios.get(`api/children/involve/list/${decypt_data}`)
        .then((res) => {
            setChildren(res.data.data); 
        });
    }, [decypt_data]);

    const onSubmit = async (values) =>{ 
        values["client_case_id"]        = decypt_data;    
        values["children_id"]           = selectedChild;
        values["id"]                    = school.id
        await updateSchool(values);
        handleClose();
    }

    function handleClickOpen() {
        setOpen(true); 
    }

    function handleClose() {
        setOpen(false);
    }

    const formik = useFormik( 
    {
        initialValues: {
            school_name: school.school_name,
            grade_attended: school.grade_attended,
            primary_teacher: school.primary_teacher,
            school_counselor: school.school_counselor
        },
        validateOnBlur:true,
        onSubmit,
        validationSchema: validationSchema
    });

    return (
        <>  
            <IconButton aria-label="update" onClick={handleClickOpen}>
                <EditIcon />
            </IconButton> 
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Create Witness</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <form onSubmit={formik.handleSubmit}>
                      <div className="form-group row"> 
                        <div className="col-lg-12 mb-4">
                            <label>Children's Name</label>   
                            <Select
                                input={<BootstrapInput />}  
                                label="Age" 
                                className={'w-100'}
                                defaultValue={school.child.id}
                                onChange={e=>setSelectedChild(e.target.value)}
                            > 
                            {
                                children && children.map((child)=> ( 
                                    <MenuItem value={child.id}>{child.firstname} {child.lastname}</MenuItem>
                                ))
                            } 
                            </Select> 
                        </div>
                        <div className="col-lg-12 mb-4">
                        <label>School Name</label>
                            <TextField
                                placeholder="School Name"
                                label="School Name"
                                name="school_name"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.school_name}
                                className="custom-border"
                                variant="outlined"
                            />
                            <br/>
                            <span className='text-danger'>
                            {formik.touched.school_name &&  formik.errors.school_name ? formik.errors.school_name:""}
                            </span>
                        </div>
                        <div className="col-lg-12 mb-4">
                            <label>Grade Attended</label>
                            <TextField
                                name="grade_attended"
                                placeholder="Grade Attended"
                                label="Grade Attended"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.grade_attended}
                                className="custom-border"
                                variant="outlined"
                            />
                            <br/>
                            <span className='text-danger'>
                            {formik.touched.grade_attended &&  formik.errors.grade_attended ? formik.errors.grade_attended:""}
                            </span>
                        </div> 
                        <div className="col-lg-12 mb-4 ">
                            <label>Primary Teacher</label>
                            <TextField
                                placeholder="Primary Teacher"
                                label="Primary Teacher"
                                name="primary_teacher"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.primary_teacher}
                                className="custom-border"
                                variant="outlined" 
                            />
                            <br/>
                            <span className='text-danger'>
                            {formik.touched.primary_teacher &&  formik.errors.primary_teacher ? formik.errors.primary_teacher:""}
                            </span>
                        </div>
                        <div className="col-lg-12 mb-4 ">
                            <label>School counselor</label>
                            <TextField
                                placeholder="School Counselor"
                                label="School Counselor"
                                name="school_counselor"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.school_counselor}
                                className="custom-border"
                                variant="outlined" 
                            />
                            <br/>
                            <span className='text-danger'>
                            {formik.touched.school_counselor &&  formik.errors.school_counselor ? formik.errors.school_counselor:""}
                            </span>
                        </div>
                      </div>  
                    
                    <DialogActions>
                        <Button onClick={handleClose} variant="contained" size="large" color="secondary">
                            Cancel
                        </Button>
                        <Button className="text-white" variant="contained" color="primary" size="large" type="submit" disabled={!formik.isValid} autoFocus>
                            Submit
                        </Button>
                      </DialogActions>
                    </form>
                </DialogContentText>
                </DialogContent> 
            </Dialog> 
        </>
    )
}

export default UpdateSchools
